import { unwrapResponse, makeApiCall } from "@payment-client/utils/Api";
import * as UpiApi from "@payment-client/interfaces/UpiApi";

const ENDPOINT = {
    VERIFY_VPA_ADDRESS: "/api/v1/vpa-verify",
};

export async function verifyVpaAddress(apiHost: string, vpaAddress: string): Promise<UpiApi.VerfiyVpaAddressResponse> {
    const response = unwrapResponse(
        await makeApiCall<UpiApi.VerfiyVpaAddressResponse>({
            apiHost,
            endpoint: ENDPOINT.VERIFY_VPA_ADDRESS,
            bodyParams: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                payer_vpa: vpaAddress,
            },
            options: {
                method: "POST",
            },
        }),
    );

    return response.unwrapOrElse(() => ({
        invalidReason: "Some Error occured.",
        vpaValid: false,
    }));
}
